// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Notice } from './Notice';
import {
    NoticeFromJSON,
    NoticeFromJSONTyped,
    NoticeToJSON,
    NoticeToJSONTyped,
} from './Notice';
import type { LineString } from './LineString';
import {
    LineStringFromJSON,
    LineStringFromJSONTyped,
    LineStringToJSON,
    LineStringToJSONTyped,
} from './LineString';
import type { OperatingPeriod } from './OperatingPeriod';
import {
    OperatingPeriodFromJSON,
    OperatingPeriodFromJSONTyped,
    OperatingPeriodToJSON,
    OperatingPeriodToJSONTyped,
} from './OperatingPeriod';
import type { ScheduledStopPoint } from './ScheduledStopPoint';
import {
    ScheduledStopPointFromJSON,
    ScheduledStopPointFromJSONTyped,
    ScheduledStopPointToJSON,
    ScheduledStopPointToJSONTyped,
} from './ScheduledStopPoint';
import type { ServiceAlteration } from './ServiceAlteration';
import {
    ServiceAlterationFromJSON,
    ServiceAlterationFromJSONTyped,
    ServiceAlterationToJSON,
    ServiceAlterationToJSONTyped,
} from './ServiceAlteration';
import type { PTSituation } from './PTSituation';
import {
    PTSituationFromJSON,
    PTSituationFromJSONTyped,
    PTSituationToJSON,
    PTSituationToJSONTyped,
} from './PTSituation';
import type { ServiceProduct } from './ServiceProduct';
import {
    ServiceProductFromJSON,
    ServiceProductFromJSONTyped,
    ServiceProductToJSON,
    ServiceProductToJSONTyped,
} from './ServiceProduct';
import type { Direction } from './Direction';
import {
    DirectionFromJSON,
    DirectionFromJSONTyped,
    DirectionToJSON,
    DirectionToJSONTyped,
} from './Direction';
import type { CheckConstraint } from './CheckConstraint';
import {
    CheckConstraintFromJSON,
    CheckConstraintFromJSONTyped,
    CheckConstraintToJSON,
    CheckConstraintToJSONTyped,
} from './CheckConstraint';

/**
 * A passenger carrying vehicle journey for one specified operation day.
 * @export
 * @interface ServiceJourney
 */
export interface ServiceJourney {
    /**
     * Underlying system specific unique identifier representing a concrete (partial) route for a specific vehicle and time. Be aware this is just a temporary id and may change daily! Additionally check for `notices` with `Notice::type=INFO`, `name=JY`, `text=<SwissJourneyId>` for a more standardized permanent [Swiss Journey-ID (SJYID)](https://transportdatamanagement.ch/content/uploads/2021/05/SwissJourneyID_DE_1_2.pdf)Data resulting out of this MUST NOT be presented to enduser (for e.g. SBB channels), set wisely! within a planning period.
     * @type {string}
     * @memberof ServiceJourney
     */
    id: string;
    /**
     * Official operating-day of the related `ServiceJourney`.
     * @type {Date}
     * @memberof ServiceJourney
     */
    operatingDay: Date;
    /**
     * 
     * @type {Array<ScheduledStopPoint>}
     * @memberof ServiceJourney
     */
    stopPoints: Array<ScheduledStopPoint>;
    /**
     * 
     * @type {Array<CheckConstraint>}
     * @memberof ServiceJourney
     */
    checkConstraints: Array<CheckConstraint>;
    /**
     * 
     * @type {Array<ServiceProduct>}
     * @memberof ServiceJourney
     */
    serviceProducts: Array<ServiceProduct>;
    /**
     * 
     * @type {ServiceAlteration}
     * @memberof ServiceJourney
     */
    serviceAlteration: ServiceAlteration;
    /**
     * 
     * @type {Array<Notice>}
     * @memberof ServiceJourney
     */
    notices: Array<Notice>;
    /**
     * 
     * @type {Array<PTSituation>}
     * @memberof ServiceJourney
     */
    situations: Array<PTSituation>;
    /**
     * 
     * @type {Array<OperatingPeriod>}
     * @memberof ServiceJourney
     */
    operatingPeriods: Array<OperatingPeriod>;
    /**
     * Depending on a train, ship or whatever Vehicle there is a specific terminology for its appropriate quay-name. Since all `stopPoints` are passed by the same Vehicle this translation is usable for all `ScheduledStopPoint::*Quay*` contained by this `ServiceJourney`. See related `quayTypeShortName` for an abbreviated translation.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceJourney
     */
    quayTypeName?: string;
    /**
     * Abbreviation for related `quayTypeName`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof ServiceJourney
     */
    quayTypeShortName?: string;
    /**
     * 
     * @type {Array<Direction>}
     * @memberof ServiceJourney
     */
    directions: Array<Direction>;
    /**
     * 
     * @type {LineString}
     * @memberof ServiceJourney
     */
    spatialProjection?: LineString;
}

/**
 * Check if a given object implements the ServiceJourney interface.
 */
export function instanceOfServiceJourney(value: object): value is ServiceJourney {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('operatingDay' in value) || value['operatingDay'] === undefined) return false;
    if (!('stopPoints' in value) || value['stopPoints'] === undefined) return false;
    if (!('checkConstraints' in value) || value['checkConstraints'] === undefined) return false;
    if (!('serviceProducts' in value) || value['serviceProducts'] === undefined) return false;
    if (!('serviceAlteration' in value) || value['serviceAlteration'] === undefined) return false;
    if (!('notices' in value) || value['notices'] === undefined) return false;
    if (!('situations' in value) || value['situations'] === undefined) return false;
    if (!('operatingPeriods' in value) || value['operatingPeriods'] === undefined) return false;
    if (!('directions' in value) || value['directions'] === undefined) return false;
    return true;
}

export function ServiceJourneyFromJSON(json: any): ServiceJourney {
    return ServiceJourneyFromJSONTyped(json, false);
}

export function ServiceJourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceJourney {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'operatingDay': (new Date(json['operatingDay'])),
        'stopPoints': ((json['stopPoints'] as Array<any>).map(ScheduledStopPointFromJSON)),
        'checkConstraints': ((json['checkConstraints'] as Array<any>).map(CheckConstraintFromJSON)),
        'serviceProducts': ((json['serviceProducts'] as Array<any>).map(ServiceProductFromJSON)),
        'serviceAlteration': ServiceAlterationFromJSON(json['serviceAlteration']),
        'notices': ((json['notices'] as Array<any>).map(NoticeFromJSON)),
        'situations': ((json['situations'] as Array<any>).map(PTSituationFromJSON)),
        'operatingPeriods': ((json['operatingPeriods'] as Array<any>).map(OperatingPeriodFromJSON)),
        'quayTypeName': json['quayTypeName'] == null ? undefined : json['quayTypeName'],
        'quayTypeShortName': json['quayTypeShortName'] == null ? undefined : json['quayTypeShortName'],
        'directions': ((json['directions'] as Array<any>).map(DirectionFromJSON)),
        'spatialProjection': json['spatialProjection'] == null ? undefined : LineStringFromJSON(json['spatialProjection']),
    };
}

  export function ServiceJourneyToJSON(json: any): ServiceJourney {
      return ServiceJourneyToJSONTyped(json, false);
  }

  export function ServiceJourneyToJSONTyped(value?: ServiceJourney | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'operatingDay': ((value['operatingDay']).toISOString().substring(0,10)),
        'stopPoints': ((value['stopPoints'] as Array<any>).map(ScheduledStopPointToJSON)),
        'checkConstraints': ((value['checkConstraints'] as Array<any>).map(CheckConstraintToJSON)),
        'serviceProducts': ((value['serviceProducts'] as Array<any>).map(ServiceProductToJSON)),
        'serviceAlteration': ServiceAlterationToJSON(value['serviceAlteration']),
        'notices': ((value['notices'] as Array<any>).map(NoticeToJSON)),
        'situations': ((value['situations'] as Array<any>).map(PTSituationToJSON)),
        'operatingPeriods': ((value['operatingPeriods'] as Array<any>).map(OperatingPeriodToJSON)),
        'quayTypeName': value['quayTypeName'],
        'quayTypeShortName': value['quayTypeShortName'],
        'directions': ((value['directions'] as Array<any>).map(DirectionToJSON)),
        'spatialProjection': LineStringToJSON(value['spatialProjection']),
    };
}

